const Loader = () => {
  return (
    <div className="w-full  h-[80dvh] flex items-center justify-center">
      <div className="bg-purple/10 h-[100px] w-[220px] rounded-xl flex items-center justify-center">
        <div className="loader text-green relative"></div>
      </div>
    </div>
  );
};

export default Loader;
